"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AUTH_STRATEGIES;
(function (AUTH_STRATEGIES) {
    AUTH_STRATEGIES["WEB_8BASE"] = "web_8base";
    AUTH_STRATEGIES["WEB_AUTH0"] = "web_auth0";
    AUTH_STRATEGIES["WEB_COGNITO"] = "web_cognito";
    AUTH_STRATEGIES["WEB_OAUTH"] = "web_oauth";
    AUTH_STRATEGIES["API_TOKEN"] = "api_token";
})(AUTH_STRATEGIES = exports.AUTH_STRATEGIES || (exports.AUTH_STRATEGIES = {}));
//# sourceMappingURL=constants.js.map